import {
  checkoutInitRoute,
  checkEligibilityRoute,
  selectLenderRoute,
  nonApprovedRoute,
  selectEmiPlanRoute,
  aivfRoute,
  transactionVerifyOtpRoute,
  paymentSuccess,
  paymentFailure,
} from '../../../alias/checkoutWidgetRoutes';
export const CHECKOUT_WIDGET_ID = 'checkout-widget-container';

export const checkoutLoaderTextHelper = {
  [checkoutInitRoute.path]: 'Initializing',
  [checkEligibilityRoute.path]: 'Loading...',
  [nonApprovedRoute.path]: 'Loading...',
  [selectLenderRoute.path]: 'Fetching lender details',
  [selectEmiPlanRoute.path]: 'Fetching EMI plans',
  [aivfRoute.path]: 'Loading...',
  [transactionVerifyOtpRoute.path]: 'Verifying details',
  [paymentSuccess.path]: 'Loading...',
  [paymentFailure.path]: 'Loading...',
};

export const ORDER_STATUS_CONFIG = {
  INITIATED: 'INITIATED',
  COMPLETE: 'COMPLETE',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
};



// WEBPACK FOOTER //
// ./components/checkoutWidget/constants/index.js